import { useQuery } from "@tanstack/react-query";
import { getWhatsAppContact } from "@/lib/contact";

/**
 * Porté depuis apps/web/app/(shop)/contact/page.tsx (Server Component async)
 * — devenu un composant client utilisant TanStack Query pour résoudre le
 * contact WhatsApp (même pattern que `SiteFooter`), `generateMetadata`
 * abandonné (hors périmètre — cf. lot SEO/prérendu séparé).
 *
 * Pas de formulaire : aucun backend d'envoi d'email/ticket n'existe côté API
 * pour ce lot (`apps/api/src/notification/` est un module vide). Simuler un
 * formulaire qui n'écrirait nulle part serait trompeur, donc le seul canal
 * proposé est WhatsApp (`getWhatsAppContact()`, déjà utilisé par le pied de
 * page).
 */
export function ContactPage() {
  const { data: whatsapp } = useQuery({
    queryKey: ["settings", "whatsapp-contact"],
    queryFn: getWhatsAppContact,
  });

  return (
    <div className="container-vvs py-8 lg:py-12">
      <h1 className="font-display text-2xl font-bold text-navy sm:text-3xl">Nous contacter</h1>
      <div className="mt-4 max-w-prose space-y-6 font-body text-sm leading-relaxed text-muted">
        <p>
          L&apos;équipe VVS répond directement sur WhatsApp&nbsp;: c&apos;est le canal le plus
          rapide pour une question sur un produit, une commande en cours ou la livraison. Aucun
          formulaire en ligne n&apos;est proposé sur cette page&nbsp;: écrivez-nous directement, un
          conseiller vous répond personnellement.
        </p>

        <div className="rounded-sm border border-line bg-white p-6 text-center">
          <h2 className="font-display text-base font-semibold text-ink">Écrivez-nous sur WhatsApp</h2>
          <p className="mt-1 text-muted">{whatsapp?.display ?? "[numéro indisponible]"}</p>
          <a
            href={whatsapp?.link ?? "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center justify-center rounded-sm bg-gold px-6 py-3 font-display text-sm font-semibold text-navy transition-colors hover:bg-goldl"
          >
            Ouvrir la conversation WhatsApp
          </a>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Disponibilité</h2>
          <p className="mt-1">
            Notre équipe est joignable du lundi au samedi. Si vous nous écrivez en dehors de ces
            jours, votre message reste visible et nous vous répondons dès que possible.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Pour une commande déjà passée</h2>
          <p className="mt-1">
            Gardez votre numéro de commande à portée de main (indiqué sur la page de confirmation
            après votre achat) : cela nous permet de retrouver votre dossier immédiatement.
          </p>
        </div>
      </div>
    </div>
  );
}
